define('tekyard_clearitems_view.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('tekyard_clearitems_view', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"hasAssetTags") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":297}}})) != null ? stack1 : "")
    + " ";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " <div class=\"clearing-items\"> "
    + ((stack1 = _nl_(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"assetTagsGrouped") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":50},"end":{"line":1,"column":282}}})) != null ? stack1 : "")
    + " </div> ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " <div class=\"asset-row\"> "
    + ((stack1 = _nl_(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":101},"end":{"line":1,"column":265}}})) != null ? stack1 : "")
    + " </div> ";
},"3":function(container,depth0,helpers,partials,data) {
    return " <div class=\"remove-item\"><button data-asset=\""
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "\" data-action=\"remove-serial-item\" type=\"button\">X</button><span>"
    + container.escapeExpression(container.lambda(depth0, depth0))
    + "</span></div> ";
},"useData":true}, 'extensions/AAMS/AAMSPDPSerialLotFunctionality/1.0.1/', 'extensions/AAMS/AAMSPDPSerialLotFunctionality/1.0.1/', Handlebars);
});